import { forwardRef } from 'react';
import styled from 'styled-components';
import { AngleSmallDown20 as IconChevron } from '@elfsight/icons';
import type { BaseButtonProps } from '../../buttons';
import { BaseButton } from '../../buttons';

export type DropdownTriggerButtonProps = Omit<
  BaseButtonProps,
  'rightSlot' | 'leftSlot'
>;

export const DropdownTriggerButton = forwardRef<
  HTMLButtonElement,
  DropdownTriggerButtonProps
>(({ children, onClick, ...forwardingProps }, forwardingRef) => {
  return (
    <Button
      {...forwardingProps}
      rightSlot={<IconChevron width={20} height={20} />}
      withOverflow
      onClick={onClick}
      ref={forwardingRef}
    >
      {children}
    </Button>
  );
});

const Button = styled(BaseButton)`
  max-width: 260px;
`;
